import { BaseResponse } from '../manager/handle_data/HandleData';
import { PaginationRequest } from '../types';
import apiService from './api.service';

export interface BackgroundDataType {
  id: number;
  data?: {
    bannerUrl?: string;
  };
  parentType: 'BACKGROUND';
}

export type BackgroundUpsertType = Partial<BackgroundDataType>;

class BackgroundService {
  async getAll(params?: PaginationRequest): Promise<BaseResponse<BackgroundDataType[]>> {
    const paramsReq = {
      parentType: 'BACKGROUND',
      ...params,
    };
    const res = await apiService.get('b/sys-config', { params: paramsReq });
    const data = res?.data?.data || [];
    return data;
  }

  async getById(id: string): Promise<BaseResponse<BackgroundDataType>> {
    const res = await apiService.get(`/b/sys-config/${id}`);
    return res.data;
  }

  async create(data: BackgroundUpsertType): Promise<BaseResponse<BackgroundDataType>> {
    const params = {
      parentType: 'BACKGROUND',
      ...data,
    };
    const res = await apiService.post('/b/sys-config', params);
    return res.data;
  }

  async update({ id, data }: { id: number; data: BackgroundUpsertType }): Promise<BaseResponse<BackgroundDataType>> {
    const params = {
      parentType: 'BACKGROUND',
      ...data,
    };
    const res = await apiService.put(`/b/sys-config/${id}`, params);
    return res.data;
  }

  async delete(id: number): Promise<BaseResponse<BackgroundDataType>> {
    const res = await apiService.delete(`/b/sys-config/${id}`);
    return res.data;
  }
}

const backgroundService = new BackgroundService();
export default backgroundService;
